import React from "react";
import { Input, Switch, Form } from "antd";
import CustomInput from "../../Common/MobileInputMask";
import { CenteredInputContainer } from "../../Common/UIElements";
import { useGetUserList } from "../../../hooks";

const GeneralInfo = (props) => {
  const { getFieldValue, validateUserName } = props;

  const { data: UsersData } = useGetUserList();

  const validateEmail = (rule, value, callback) => {
    const id = getFieldValue("_id");
    if (value) {
      const currentUser = UsersData?.data?.find((user) => user._id === id);
      if (currentUser?.email === value) callback();
      const isEmailExist = UsersData?.data?.find(
        (user) => user.email === value && user._id !== id,
      );
      if (isEmailExist) {
        callback(
          "The entered email address is already linked to an existing account",
        );
      } else callback();
    } else callback();
  };

  return (
    <CenteredInputContainer>
      <Form.Item label="Id" name="_id" style={{ display: "none" }}>
        <Input />
      </Form.Item>
      <Form.Item
        label="User Name"
        name="user_name"
        rules={[
          {
            required: false,
            message: "Please Enter User Name",
          },
          {
            validator: validateUserName,
          },
        ]}
      >
        <Input
          placeholder="Enter User Name"
          disabled={
            typeof getFieldValue("_id") === "string" &&
            getFieldValue("_id").length > 0
          }
        />
      </Form.Item>
      <Form.Item
        label="First Name"
        name="first_name"
        rules={[
          {
            required: true,
            message: "Please Enter First Name",
          },
        ]}
      >
        <Input placeholder="Enter First Name" />
      </Form.Item>
      <Form.Item
        label="Last Name"
        name="last_name"
        rules={[
          {
            required: true,
            message: "Please Enter Last Name",
          },
        ]}
      >
        <Input placeholder="Enter Last Name" />
      </Form.Item>

      <Form.Item
        label="Email"
        name="email"
        rules={[
          {
            required: true,
            message: "Please Enter Email",
          },
          {
            type: "email",
            message: "Please Enter Valid Email",
          },
          {
            validator: validateEmail,
            warningOnly: true,
          },
        ]}
      >
        <Input placeholder="Enter Email" />
      </Form.Item>

      <Form.Item
        label="Mobile"
        name="mobile"
        validateTrigger="onChange"
        rules={[
          {
            pattern: new RegExp(/(\d{3})-(\d{3})-(\d{4})/),
            message: "Please Enter a Valid Mobile Number",
          },
        ]}
      >
        <CustomInput mask="999-999-9999" placeholder="Enter Mobile Number" />
      </Form.Item>

      {/* <Form.Item label="Status" name="status">
        <Radio.Group>
          <Radio value="1">Activate</Radio>
          <Radio value="0">Deactivate</Radio>
        </Radio.Group>
      </Form.Item> */}
      <Form.Item
        label="Two Factor Authentication (2FA)"
        name="use_mfa"
        valuePropName="checked"
      >
        <Switch />
      </Form.Item>
    </CenteredInputContainer>
  );
};

GeneralInfo.propTypes = {};

export default GeneralInfo;
